import { createApp } from '@app/adapters/create-app'
import MigrateMappingListProgress from '@app/application/admin/special-actions/migrate-mapping-list-progress'

onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='migrate-mapping-list-progress']")
    .each(function () {
      const app = createApp(MigrateMappingListProgress, {
        channelName: $(this).data('messagebus-channel'),
        lastChannelId: $(this).data('messagebus-last-id'),
        initialProgress: parseFloat($(this).data('progress')),
      })

      app.mount(this)
    })
})
